module.exports = __webpack_public_path__ + "img/item6.c177a9b3.png";